export namespace DynamicForm {
	export class AnswerInfo {
		Id: number;
		QuestionId: number;
		StringValue: string | null;
		IntValue: number | null;
		BoolValue: boolean | null;
		Choices: Array<number>;
		Valid: () => boolean | undefined;
	}
}
